const sx = {
  root: {
    backgroundColor: '#122549',
    color: 'white',
    py: { xs: 6, md: 8 },
  },
  logoContainer: {
    width: '100%',
    maxWidth: 220,
    mb: 2,
  },
  titleText: {
    fontWeight: 700,
    fontSize: '1rem',
    lineHeight: 1.3,
  },
  bodyText: {
    color: '#D1D5DB',
    fontSize: '0.875rem',
    lineHeight: 1.5,
  },
  copyrightText: {
    color: '#9CA3AF',
    fontSize: '0.8rem',
    mt: 2,
  },
  socialIcons: {
    color: 'white',
    transition: 'color 0.2s',
    '&:hover': {
      color: '#A0AABF',
    },
  },
  linkText: {
    color: 'white',
    fontWeight: 600,
    fontSize: '1rem',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}

export default sx
